import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material';
import {
  localeSelector,
  organizationNameSelector,
  userNamesSelector,
  userSelector,
  isBetaUserSelector,
} from 'domain/env';
import { currentCompanyNameSelector } from 'domain/companies';
import { currentConnectedERPselector } from 'domain/settings';
import openFreshDeskChat from 'lib/freshdeskChat/openFreshDeskChat';

const mapStateToProps = (state) => ({
  organizationName: organizationNameSelector(state),
  currentCompanyName: currentCompanyNameSelector(state),
  currentConnectedERP: currentConnectedERPselector(state),
  locale: localeSelector(state),
  userName: userNamesSelector(state),
  email: userSelector(state).userId,
  isBetaUser: isBetaUserSelector(state),
});

const useOpenChat = () => {
  const { email, userName, organizationName, currentCompanyName, currentConnectedERP, locale, isBetaUser } =
    useSelector(mapStateToProps);
  const { labelOptions } = useTheme();

  return useCallback(() => {
    const { name, supportEmail } = labelOptions;
    if (name !== 'AlPrime') {
      openFreshDeskChat({
        email,
        organizationName,
        currentCompanyName,
        currentConnectedERP,
        userName,
        locale,
        isBetaUser,
      });
    } else {
      window.location = `mailto:${supportEmail}`;
    }
  }, [labelOptions, email, organizationName, currentCompanyName, currentConnectedERP, userName, locale, isBetaUser]);
};

export default useOpenChat;
